import React from "react";

import { wrap } from "./RydTestbedWrap";
import PianoRoll from "../components/rolls/PianoRoll";
import DemoData from "../utils/DemoData";
import { CONTEXT } from "./EurydiceTestbed";
import { FULL_RANGE } from "../components/pickers/NoteRangeSelector";
import {
    RydTrack,
    RydTrackUIState
} from "../model/tracks";
import { TrackColor } from "../render/trackColor";
import { RydProject } from "../model/project";


function uiState(): RydTrackUIState {
    return {
        trackId: 1,
        collapsed: false,
        noteRange: FULL_RANGE,
        tonalityVisible: false,
        color: TrackColor.DEFAULT_COLOR,
    };
}

function makeTrack() : RydTrack {
    return {
        id: 1,
        name: 'Test Track',
        length: 32,
        color: TrackColor.getRandomColor(),
        sequence: DemoData.empty(32),
        bookmarks: [],
    }
}

export function PianoRollTestbed() {

    return wrap((<>
        <h2>Piano rolls</h2>

        <h3>Readonly</h3>
        <PianoRoll
            project={RydProject.createForNewProject('Test Project')}
            uiState={{ ...uiState(), noteRange: { min: 57, max: 76 } }}
            readonly={true}
            hnc={DemoData.majorTriads()}
            track={makeTrack()}
            setTrack={() => { }}
            contextFrame={CONTEXT}
            setTrackUIState={() => { }}
        />

        <h3>Read-write, empty</h3>
        <PianoRoll
            project={RydProject.createForNewProject('Test Project')}
            readonly={false}
            hnc={DemoData.empty(32)}
            track={makeTrack()}
            setTrack={() => { }}
            contextFrame={CONTEXT}
            uiState={uiState()}
            setTrackUIState={() => { }}
        />

        <h3>Read-write, empty, different size</h3>
        <PianoRoll
            project={RydProject.createForNewProject('Test Project')}
            readonly={false}
            hnc={DemoData.empty(4)}
            track={makeTrack()}
            setTrack={() => { }}
            contextFrame={CONTEXT}
            uiState={uiState()}
            setTrackUIState={() => { }}
        />
    </>));
}